import { usePageViewTracking } from "../../utils/analytics";

export const PageTracker = () => {
  usePageViewTracking();
  return null;
};
